import { Component, OnInit } from '@angular/core';
import {CuponsService} from "../../../superadmin/services/cupons.service";
import {
  TelaAssociarCupomContatosComponent
} from "../../tela-associar-cupom-contatos/tela-associar-cupom-contatos.component";
import {CadCupomComponent} from "../../cad-cupom/cad-cupom.component";
import {DialogService} from "@progress/kendo-angular-dialog";
import {EnumTipoDeCupom} from "../../../../../server/lib/emun/EnumTipoDeCupom";

@Component({
  selector: 'app-grid-cupons',
  templateUrl: './grid-cupons.component.html',
  styleUrls: ['./grid-cupons.component.scss']
})
export class GridCuponsComponent implements OnInit {
  cupons:  any = []
  mensagemCopiada: string;
  timerCopiado;
  cupomRestrito: any;
  modalDeletar: boolean;
  cupomApagar: any;
  carregando: boolean;
  // a aba vem do status calculado na carga: pausar um cupom não o tira da aba na hora
  abas = [
    { id: 'Ativos', rotulo: 'Ativos' },
    { id: 'Desativados', rotulo: 'Pausados' },
    { id: 'Vencidos', rotulo: 'Vencidos' }
  ];
  abaAtual = 'Ativos';
  busca = '';
  constructor( private dialogService: DialogService,
               private cuponsService: CuponsService) { }

  ngOnInit(): void {
  }

  setCupons(cupons: any) {
    this.cupons = cupons;
    this.cupons.forEach((cupom: any) => {
       if(cupom.ativo && !cupom.vencido){
         cupom.status = 'Ativos'
       } else {
         if(cupom.vencido){
           cupom.status = 'Vencidos'
         } else {
           cupom.status = 'Desativados'
         }
       }
    })

    const posicaoNaAba: any = {};
    this.cupons.forEach((cupom: any) => {
      posicaoNaAba[cupom.status] = (posicaoNaAba[cupom.status] || 0) + 1;
      cupom.cor = (posicaoNaAba[cupom.status] - 1) % 6;
    })
    this.carregando = false;
  }

  cuponsDaAba(): Array<any> {
    return this.cuponsFiltrados().filter( (cupom: any) => cupom.status === this.abaAtual);
  }

  totalDaAba(aba: string): number {
    return this.cuponsFiltrados().filter( (cupom: any) => cupom.status === aba).length;
  }

  textoAbaVazia(): string {
    if(this.abaAtual === 'Desativados') return 'Nenhum cupom pausado.';
    if(this.abaAtual === 'Vencidos') return 'Nenhum cupom vencido.';
    return 'Nenhum cupom ativo agora.';
  }

  porId(indice: number, cupom: any) {
    return cupom.id;
  }

  statusDo(cupom: any): { id: string, rotulo: string } {
    if(cupom.vencido) return { id: 'vencido', rotulo: 'Vencido' };
    return cupom.ativo ? { id: 'ativo', rotulo: 'Ativo' } : { id: 'pausado', rotulo: 'Pausado' };
  }

  valorDoDesconto(cupom: any): string {
    if(cupom.tipo === EnumTipoDeCupom.FreteGratis) return 'Grátis';

    const valor = this.ehPercentual(cupom) ? `${cupom.percentual || 0}%` : this.formateReais(cupom.valor || 0);

    return cupom.aplicarNaFidelidade ? `+${valor}` : valor;
  }

  rotuloDoDesconto(cupom: any): string {
    if(cupom.tipo === EnumTipoDeCupom.FreteGratis) return 'na entrega';
    if(cupom.aplicarNaFidelidade) return 'de cashback';
    if(cupom.aplicarNaTaxaDeEntrega) return 'na entrega';
    return 'em produtos';
  }

  // cor por cupom: a maioria é "em produtos", então cor por tipo deixava a lista
  // toda igual; o tipo fica no ícone e na etiqueta do canhoto. Distribuída pela
  // posição dentro da aba (setCupons), para dois vizinhos nunca repetirem a cor.
  corDo(cupom: any): number {
    return cupom.cor || 0;
  }

  temaDo(cupom: any): string {
    if(cupom.tipo === EnumTipoDeCupom.FreteGratis || cupom.aplicarNaTaxaDeEntrega) return 'entrega';
    if(cupom.aplicarNaFidelidade) return 'cashback';
    return this.ehPercentual(cupom) ? 'percentual' : 'valor';
  }

  iconeDoTema(cupom: any): string {
    const icones: any = { entrega: 'fe-truck', cashback: 'fe-zap', percentual: 'fe-percent', valor: 'fe-dollar-sign' };
    return icones[this.temaDo(cupom)];
  }

  textoDias(cupom: any): string {
    return (cupom.horarios || []).map( (horario: any) => this.getDia(horario.dia)).join(', ');
  }

  // condições que mudam quem usa e em qual pedido; lista de contatos tem botão próprio
  regrasDo(cupom: any): Array<string> {
    const regras = [];

    if(cupom.primeiraCompra) regras.push('Só 1ª compra');
    if(cupom.restrito && cupom.restritoContatoPerdido) regras.push('Contatos perdidos');
    if(cupom.restritoAniversariantes) regras.push('Aniversariantes');

    const canais: any = { loja: 'Só no cardápio', app: 'Só no aplicativo', mesas: 'Só em mesas' };
    if(canais[cupom.escopo]) regras.push(canais[cupom.escopo]);

    const formas: any = { delivery: 'Só delivery', retirada: 'Só retirada', comerlocal: 'Só comer no local' };
    if(formas[cupom.formaEntrega]) regras.push(formas[cupom.formaEntrega]);

    const pagamentos = this.nomes(cupom.formasDePagamento, 'descricao');
    if(pagamentos.length)
      regras.push(pagamentos.length <= 2 ? `Só ${pagamentos.join(' ou ')}` : `${pagamentos.length} formas de pagamento`);

    const exigidos = this.nomes(cupom.produtos, 'nome').concat(this.nomes(cupom.categorias, 'nome'));
    if(exigidos.length)
      regras.push(exigidos.length === 1 ? `Com ${exigidos[0]}` : `Exige ${exigidos.length} itens`);

    if(cupom.quantidade) regras.push(`${cupom.quantidade} usos no total`);
    if(cupom.qtdeMaxima) regras.push(`${cupom.qtdeMaxima} por cliente`);
    if(cupom.selecionavel) regras.push('Visível na loja');

    return regras;
  }

  alterneAtivo(cupom: any) {
    if(cupom.ativo) this.desativarCupom(cupom);
    else this.ativarCupom(cupom);
  }

  abraDialogRemover(cupom: any) {
    this.cupomApagar = cupom;

    this.modalDeletar = true;
  }

  private cuponsFiltrados(): Array<any> {
    const busca = (this.busca || '').trim().toLowerCase();
    if(!busca) return this.cupons;

    return this.cupons.filter( (cupom: any) =>
      String(cupom.codigo || '').toLowerCase().indexOf(busca) >= 0 || String(cupom.nome || '').toLowerCase().indexOf(busca) >= 0);
  }

  private ehPercentual(cupom: any): boolean {
    if(cupom.tipo) return cupom.tipo === EnumTipoDeCupom.Percentual;
    return cupom.percentual > 0;
  }

  private nomes(itens: Array<any>, campo: string): Array<string> {
    return (itens || []).filter( (item: any) => item && item.id && item[campo]).map( (item: any) => item[campo]);
  }

  private formateReais(valor: number): string {
    const digitos = Number(valor) % 1 === 0 ? 0 : 2;

    return 'R$ ' + Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: digitos, maximumFractionDigits: digitos });
  }

  copyMessage(val: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.mensagemCopiada = val;
    clearTimeout(this.timerCopiado);
    this.timerCopiado = setTimeout(() => this.mensagemCopiada = null, 2000);
  }

  exibaListaContatos(cupom: any) {
    if(cupom.restrito){
      this.cupomRestrito = cupom;
    }
  }

  canceleRemocao() {
    this.modalDeletar = false;
    delete    this.cupomApagar;
  }

  confirmeRemocao() {
    let i = this.cupons.indexOf(this.cupomApagar);

    this.cuponsService.removaCupom(this.cupomApagar).then( () => {
      this.cupons.splice(i, 1);
    }).catch( erro => {
      alert(erro)
    })

    this.canceleRemocao();

  }

  desativarCupom(cupom: any) {
    cupom.ativo = false;
    cupom.processando = true;
    this.cuponsService.desativeCupom(cupom).then( () => {
      cupom.processando = false;
    }).catch( erro => {
      cupom.ativo = true;
      cupom.processando = false;
      alert(erro)
    })
  }

  ativarCupom(cupom: any) {
    cupom.ativo = true;
    cupom.processando = true;
    this.cuponsService.ativeCupom(cupom).then( () => {
      cupom.processando = false;
    }).catch( erro => {
      cupom.ativo = false;
      cupom.processando = false;
      alert(erro)
    })
  }

  criarCupom() {
    this.abraModalCupom();

  }

  editarCupom(cupom: any) {
    this.abraModalCupom(cupom);
  }

  public abraModalAssociarContatos(cupom: any = null){
    let altura = window.innerHeight - 100;

    const windowRef = this.dialogService.open({
      title: String(`Cupom ${cupom.nome}  `),
      content: TelaAssociarCupomContatosComponent,
      minWidth: 500,
      width: window.innerWidth > 600 ? 600 : window.innerWidth,
      maxHeight: altura
    });

    const telaCupom: TelaAssociarCupomContatosComponent = windowRef.content.instance;

    telaCupom.windowRef = windowRef;

    if(cupom && cupom.id)
      telaCupom.cupom = cupom;

    windowRef.result.subscribe((result: any) => {

    });
  }

  private abraModalCupom(cupom: any = null) {
    // altura fixa: a lateral e o rodapé ficam parados e só o conteúdo da seção rola
    let altura = Math.min(window.innerHeight - 40, 760);

    const windowRef = this.dialogService.open({
      title: cupom && cupom.id ? 'Editar cupom' : 'Novo cupom',
      content: CadCupomComponent,
      cssClass: 'dialog-cad-cupom',
      minWidth: 250,
      width: window.innerWidth > 920 ? 920 : window.innerWidth,
      height: altura
    });

    const telaCupom: CadCupomComponent = windowRef.content.instance;

    telaCupom.windowRef = windowRef;

    if(cupom && cupom.id)
      telaCupom.cupom = cupom;

    windowRef.result.subscribe((result: any) => {
      if(result && result.id){
        this.carregando = true;
        this.cupons = [];
        this.cuponsService.listeCupons({ listavel: true }).then( (resposta) => {
          this.setCupons(resposta)
        })
      }

    });
  }

  getDia(dia: number){
    let dias = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab']


    return dias[dia]

  }



}
